import axios from 'axios'

import { config } from '../../common/config'

// https://github.com/envato/customer-market-homepage-jobs/blob/master/docs/decisions/001-blob-folder-structure.md

// https://s3.amazonaws.com/market-shopfront-staging-api-data-us-east-1/home-page/3docean/newest-items/index.json
export const getDataFromS3 = <T>(path: string) => {
  return axios.get<T>(`${config.HOMEPAGE_JSON_BUCKET_URL}/${path}`)
}

// https://api-data.shopfront.envato.com/3docean/home-page/newest-items/index.json
export const getDataFromCloudfront = <T>(path: string) => {
  return axios.get<T>(`${config.HOMEPAGE_JSON_CDN_URL}/${path}`)
}
